<template>
  <v-container fluid class="pa-0 white-background">
    <v-container flat class="white-background" id="questions">
      <section>
        <v-container fluid class="pl-0 pt-0 pr-0 pb-0 mb-0">
          <v-flex sm10 xs12 offset-sm1>
            <div class="text-xs-center blue-text">
              <h2 class="headline" v-on:dblclick="jumpToEnd">Resilience Survey</h2>
            </div>
          </v-flex>
        </v-container>
        <!-- Progress bar. See:
          https://www.surveymonkey.com/curiosity/progress-bars-good-bad-survey-survey-says/
        https://www.quicktapsurvey.com/blog/survey-progress-bars-are-they-in-or-out/-->
        <v-container fluid class="pl-0 pt-0 pr-0 pb-0 mb-0">
          <v-flex sm10 xs12 offset-sm1>
            <v-progress-linear
              v-model="completionRatioPercentage"
              color="#60e060"
              background-color="rgba(170, 170, 170, 0.8)"
              height="10"
              class="pb-0 ma-0 rounded-bar"
            ></v-progress-linear>
          </v-flex>
        </v-container>
      </section>
      <!-- This is a tabs container, to give us a stepper effect    -->
      <!-- with only one page visible at a time. The height of the  -->
      <!-- tabs panel is set to 0, to hide it. This does not affect -->
      <!-- the functionality of the stepping, but users are unable  -->
      <!-- to jump to a specific tab/question.                      -->
      <!-- This is a tabs container, to give us a stepper effect    -->
      <!-- with only one page visible at a time. The height of the  -->
      <!-- tabs panel is set to 0, to hide it. This does not affect -->
      <!-- the functionality of the stepping, but users are unable  -->
      <!-- to jump to a specific tab/question.                      -->
      <v-tabs height="0" light v-model="active" color="yellow" 
        @change="onTabChange" class="pt-0 mt-0"
      >
        <v-tab v-for="ti in tabIndices" :key="'question' + ti" ripple>{{ ti == questions.length ? 'thankyou' : questions[ti].name }}></v-tab>
        <v-tab-item
          v-for="(question, index) in questions"
          :key="question.name"
          ignore-transition="slow-x-transition"
          ignore-reverseTransition="slow-x-reverse-transition"
        >
          <div class="tab-item-wrapper">
            <v-layout width="100%">
              <v-flex xs12 sm10 offset-sm1>
                <v-card light flat>
                  <v-card-title primary-title class="mb-0 pb-1">
                    <div class="blue-text">
                      <h1 class="headline mb-0 font-weight-bold">{{ question.headline }}</h1>
                      <!--<div class="title">{{ question.headline }}</div>-->
                      <span class="body-1">{{ question.hint }}</span>
                    </div>
                  </v-card-title>
                  <v-card-text class="fill-vertical pt-1 pb-1">
                    <RadioQuestion 
                      v-if="question.type == 'radio'"
                      :qid="question.id" 
                      :showTools="false" 
                      v-on:completed="onPageCompleted"
                      v-on:testall="onTestAll">
                    </RadioQuestion>
                    <FlagQuestion 
                      v-if="question.type == 'flags'"
                      :qid="question.id" 
                      :showTools="false" 
                      v-on:completed="onPageCompleted">
                    </FlagQuestion>
                    <ScoresQuestion
                      v-if="question.type == 'scores'"
                      :qid="question.id" 
                      :showTools="false" 
                      v-on:completed="onPageCompleted">
                    </ScoresQuestion>
                  </v-card-text>
                  <v-card-actions class="pt-0 justify-center">
                    <v-btn
                      color="primary"
                      v-if="hasNext(question, index)"
                      v-bind:disabled="!canMoveForward()"
                      @click="gotoNext(question, index)"
                    >Next</v-btn>
                    <v-btn
                      flat
                      v-if="hasGoBack(question, index)"
                      @click="gotoBack(question, index)"
                    >Go Back</v-btn>
                  </v-card-actions>
                </v-card>
              </v-flex>
            </v-layout>
          </div>
        </v-tab-item>
        <v-tab-item key='thankyou'>
          <v-layout width="100%" id="thankyou">
            <v-flex xs12 sm10 offset-sm1 pt-4>
              <v-card v-if="completionRatio == 1" light>
                <v-card-title class="pb-0">
                  <div class="blue-text">
                    <h1 class="headline">Thank you</h1>
                    <span class="body-1">
                      That's all the information we need to create your report.
                      Click below to look at your report, or go back and change your answers.
                    </span>
                  </div>
                </v-card-title>
                <v-card-actions class="justify-center">
                  <v-btn
                    class="blue-text yellow-background justify-center align-center"
                    dark
                    large
                    round
                    to="/report"
                  >Get your report
                    <!--<v-icon right>view_list</v-icon>-->
                  </v-btn>
                  <v-btn
                    flat
                    @click="gotoLast"
                  >Go Back</v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>
        </v-tab-item>
      </v-tabs>
    </v-container>
  </v-container>
</template>

<script>
import RadioQuestion from "./RadioQuestion.vue";
import FlagQuestion from "./FlagQuestion.vue";
import ScoresQuestion from "./ScoresQuestion.vue";
import { overrideQuestionModel } from "../model/override-question-model.js";
import { completionMap } from "../model/completion-map.js"
import { range } from "../utils/std.js";

export default {
  name: "QuestionnaireTabs",
  components: {
    RadioQuestion,
    FlagQuestion,
    ScoresQuestion
  },
  data() {
    return {
      active: 0
    }
  },
  computed: {
    questions: function() { return overrideQuestionModel.enrichModel() },
    tabIndices: function() { return range(0, this.questions.length) }, 
    completionRatio: function() { return completionMap.getCompletionRatio(this.active) }, 
    completionRatioPercentage: function() { return this.completionRatio * 100.0 }, 
  },
  methods: {
    questionMap: function() { return completionMap.getQuestionMap() }, // NOT computed - caching is dealt with at source
    onTabChange: function() {}, // TODO - remove if not used
    // eslint-disable-next-line no-unused-vars
    hasNext: function(question, index) { 
      return true 
    }, 
    canMoveForward: function() { 
      if (this.active >= this.questions.length)
        return false
      const q = this.questions[this.active]
      return this.$store.getters.getQuestionHasAllValues(q.id)
    },
    // eslint-disable-next-line no-unused-vars
    hasGoBack: function(question, index) {
      const qm = this.questionMap();
      return ((this.active < qm.length) && qm[this.active].hasPrev)
          || (this.active == qm.length)
    },
    // eslint-disable-next-line no-unused-vars
    gotoNext(question, index) {
      const qm = this.questionMap(); 
      let dest = this.active < qm.length ? qm[this.active].nextIndex : -1;
      // console.log('qm used')
      // console.log(qm)
      // if (dest < 0) {
      //   console.log('gotoNext: ' 
      //     + this.questions[this.active].id + '@' + this.active + ' => farewell')
      // }
      // else {
      //   console.log('gotoNext: ' 
      //     + this.questions[this.active].id + '@' + this.active + ' => ' 
      //     + this.questions[dest].id + '@' + dest)
      // }
      // The user is accepting all the answers on this page (which may 
      // have been set from saved data or defaults)
      this.$store.commit("acceptQuestion", { id: this.questions[this.active].id });
      // Change page
      if (dest >= 0) {
        this.active = dest;
      } else if (this.completionRatio == 1) {
        this.active = qm.length;
      }
    },
    // eslint-disable-next-line no-unused-vars
    gotoBack(question, index) {
      const qm = this.questionMap();
      let dest = this.active < qm.length ? qm[this.active].prevIndex : -1;
      if (dest >= 0) {
        this.active = dest;
      }
    },
    gotoLast() {
      const qm = this.questionMap();
      let dest = completionMap.getLastQuestionIndex(qm)
      this.active = dest
    },
    onPageCompleted() {
      //console.log('onPageCompleted')
      // Note - this will also cause store.commit("acceptQuestion"),
      // which will change preset answers to userSet = true
      this.gotoNext(null, this.active)
    },
    // Test only
    onTestAll() {
      this.$store.commit('applySavedValues', {whichSet: 1, userSet: true})
      this.gotoLast() // Do this in two steps, to force the completionMap to be rebuilt 
      this.gotoNext()
    },
    jumpToEnd() {
      this.$store.commit('acceptAllQuestions')
      this.gotoLast() // Do this in two steps, to force the completionMap to be rebuilt 
      this.gotoNext()
    }
  }
}
</script>

<style>

</style>